var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content warn-rule" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showMainList,
              expression: "showMainList"
            }
          ],
          staticClass: "main-content",
          attrs: { type: "primary" }
        },
        [
          _c("div", { staticClass: "cargo-advance-search" }, [
            _c(
              "div",
              {
                staticClass: "cargo-advance-search quotation-client-search",
                staticStyle: { height: "auto", width: "100%" }
              },
              [
                _c(
                  "div",
                  { staticClass: "cargo-advance-search-header" },
                  [
                    _c(
                      "el-form",
                      {
                        staticStyle: {
                          "margin-right": "5px",
                          "min-width": "1100px"
                        },
                        attrs: {
                          "label-width": "65px",
                          "label-position": "left"
                        }
                      },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 10 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 4 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_BusinessType"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        "select-type":
                                          _vm.selectTypeNames
                                            .local_cache_SystemConstants$LOBS,
                                        "show-custom-label-in-option": true,
                                        "default-value": _vm.filter.lob,
                                        clearable: false
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.lob = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_SopTemplate"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        "static-options": _vm.lobTemplates,
                                        cache: false,
                                        "tag-value": "uuid",
                                        "tag-name": "templateName",
                                        "default-value":
                                          _vm.filter.trackingTemplateUuid
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.trackingTemplateUuid =
                                            p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_WarningConditions"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        cache: false,
                                        "static-options": _vm.alertTypes,
                                        "default-value":
                                          _vm.filter.warningDateField,
                                        "tag-value": "code",
                                        filterable: ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.warningDateField = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_WarningContent"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.filter.content,
                                        callback: function($$v) {
                                          _vm.$set(_vm.filter, "content", $$v)
                                        },
                                        expression: "filter.content"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "SystemMaintenance.ConfigurationName"
                                      )
                                    }
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.filter.configureName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filter,
                                            "configureName",
                                            $$v
                                          )
                                        },
                                        expression: "filter.configureName"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 5 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "label-max",
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      label: _vm.$t(
                                        "CargoMsg.Cargo_AlertOnStatus"
                                      )
                                    }
                                  },
                                  [
                                    _c("cargo-advance-select", {
                                      staticStyle: { width: "100px" },
                                      attrs: {
                                        cache: false,
                                        "static-options": _vm.switchList,
                                        "default-value": _vm.filter.open,
                                        "tag-value": "code",
                                        filterable: ""
                                      },
                                      on: {
                                        parentCallBack: function(p) {
                                          _vm.filter.open = p.value
                                        }
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "flex-start"
                        }
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.toQuery }
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("Pricing.Query")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: ["SE"].indexOf(_vm.filter.lob) > -1,
                                expression:
                                  "['SE'/*, 'AE'*/].indexOf(filter.lob) > -1"
                              }
                            ],
                            attrs: { type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.onDataServiceReminder()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_DataServiceReminder")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: ["SE"].indexOf(_vm.filter.lob) > -1,
                                expression:
                                  "['SE'/*, 'AE'*/].indexOf(filter.lob) > -1"
                              }
                            ],
                            attrs: { type: "success" },
                            on: {
                              click: function($event) {
                                return _vm.onValueAddedServiceReminder()
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_ValueAddedServiceReminder"
                                )
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.onEdit()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onClose()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Close")))]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            )
          ])
        ]
      ),
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            { staticClass: "section grid-wrapper" },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  "config-module": "260306",
                  "wrap-text": true,
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "260306",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.toQuery
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm.warnRuleFormDialog.visible
        ? _c("warn-rule-form", {
            attrs: {
              visible: _vm.warnRuleFormDialog.visible,
              readonly: false,
              source: _vm.warnRuleFormDialog.form,
              "alert-types": _vm.warnRuleFormDialog.alertTypes,
              "complete-node-status": _vm.warnRuleFormDialog.completeNodeStatus
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.warnRuleFormDialog, "visible", $event)
              },
              "update:alertTypes": function($event) {
                return _vm.$set(_vm.warnRuleFormDialog, "alertTypes", $event)
              },
              "update:alert-types": function($event) {
                return _vm.$set(_vm.warnRuleFormDialog, "alertTypes", $event)
              },
              reload: _vm.clearSelectRow,
              close: function($event) {
                _vm.warnRuleFormDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.reminderFormDialog.visible
        ? _c("data-service-reminder-form", {
            attrs: {
              visible: _vm.reminderFormDialog.visible,
              readonly: false,
              params: _vm.filter,
              "load-data": _vm.loadData,
              "alert-types": _vm.reminderFormDialog.alertTypes,
              "open-subscribe": _vm.openSubscribe
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.reminderFormDialog, "visible", $event)
              },
              "update:alertTypes": function($event) {
                return _vm.$set(_vm.reminderFormDialog, "alertTypes", $event)
              },
              "update:alert-types": function($event) {
                return _vm.$set(_vm.reminderFormDialog, "alertTypes", $event)
              },
              reload: _vm.toQuery,
              close: function($event) {
                _vm.reminderFormDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.valueAddedFormDialog.visible
        ? _c("ams-vgm-reminder-form", {
            attrs: {
              visible: _vm.valueAddedFormDialog.visible,
              readonly: false,
              params: _vm.filter
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.valueAddedFormDialog, "visible", $event)
              },
              reload: _vm.toQuery,
              close: function($event) {
                _vm.valueAddedFormDialog.visible = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }